export default function getValue(testName) {
  const name = findTestName(testName);

  if (name) {
    return window.ab_tests[name];
  }

  return null
}

/*
 * window.ab_tests stores test names with version, which means
 * download_button_everywhere test can be stored as
 * download_button_everywhere (for version 0) or download_button_everywhere:42
 * This function finds the name
 */
function findTestName(testName) {
  if (!window.ab_tests) {
    return null;
  }

  const nameWithColon = `${testName}:`;

  return Object.keys(window.ab_tests)
    .find((n) => n == testName || n.startsWith(nameWithColon));
}
